import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _class2, _descriptor, _descriptor2;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { runInAction, observable } from 'mobx';
import { observer } from 'mobx-react';
import ProgressSpinner from '../../../components/ProgressSpinner';
import Icon from '../../../components/Icon';
import { ScopeChangeRequestBanner } from 'messaging/components/ScopeChangeRequestBanner';
import './styles.sass';
import { isMobile } from '../../../utils/mobileDetect';
var TOP_THRESH = 800;
var BOTTOM_THRESH = isMobile() ? 200 : 100;
var MessageScrollView = observer(_class = (_class2 = /*#__PURE__*/function (_Component) {
  function MessageScrollView() {
    var _this;
    _classCallCheck(this, MessageScrollView);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MessageScrollView, [].concat(args));
    _initializerDefineProperty(_this, "shouldScrollBottom", _descriptor, _this);
    _initializerDefineProperty(_this, "isNearBottom", _descriptor2, _this);
    _this.scroll = function () {
      _this.checkScroll();
    };
    return _this;
  }
  _inherits(MessageScrollView, _Component);
  return _createClass(MessageScrollView, [{
    key: "scrollToBottom",
    value: function scrollToBottom() {
      var animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (this.root && this.root.scrollHeight) {
        if (animate) {
          this.root.scrollTo({
            top: this.root.scrollHeight,
            behavior: 'smooth'
          });
        } else {
          this.root.scrollTop = this.root.scrollHeight;
        }
      }
    }
  }, {
    key: "checkScroll",
    value: function checkScroll() {
      var _this2 = this;
      var node = this.root;
      var scrollTop = node.scrollTop,
        offsetHeight = node.offsetHeight,
        scrollHeight = node.scrollHeight;

      // Auto-scroll if we're at the bottom of the view
      var shouldScrollBottom = offsetHeight === scrollHeight || scrollTop + offsetHeight > scrollHeight;

      // Threshold check for showing the scroll button
      var isNearBottom = offsetHeight === scrollHeight || scrollTop + offsetHeight > scrollHeight - BOTTOM_THRESH;
      if (this.props.onLoadMore) {
        if (scrollTop < TOP_THRESH) {
          if (this._shouldNotifyLoadMore || scrollTop === 0) {
            this._shouldNotifyLoadMore = false;
            this.props.onLoadMore();
          }
        } else {
          this._shouldNotifyLoadMore = true;
        }
      }
      runInAction(function () {
        _this2.shouldScrollBottom = shouldScrollBottom;
        _this2.isNearBottom = isNearBottom;
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;
      // Scroll immediately first
      this.scrollToBottom(false);

      // Then request another scroll after next paint to ensure final height
      // Do you hate this as much as I do?
      this.timer = setTimeout(function () {
        return _this3.scrollToBottom(false);
      }, 100);
    }
  }, {
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate(nextProps) {
      // Record scroll position and children count.
      this._scrollPos = this.root.scrollTop;
      this._scrollHeight = this.root.scrollHeight;
      // if the next props says we have more messages,
      // we need to save the scroll position so we can
      // restore it after adding more messages.
      this._shouldSetScroll = this.props.messageCount < nextProps.messageCount;
      this.checkScroll();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var node = this.root;
      if (this._shouldSetScroll) {
        // If more messages load maintain the scroll position
        var heightDiff = node.scrollHeight - this._scrollHeight;
        node.scrollTop = heightDiff + this._scrollPos;
        this._shouldSetScroll = false;
      } else if (this.shouldScrollBottom) {
        // Scroll if a new message is added and we're at the bottom
        this.scrollToBottom();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props = this.props,
        children = _this$props.children,
        isLoadingMore = _this$props.isLoadingMore,
        scrollToBottom = _this$props.scrollToBottom,
        typingIndicator = _this$props.typingIndicator;
      return /*#__PURE__*/React.createElement("div", {
        className: "message-scroll-view"
      }, isLoadingMore && /*#__PURE__*/React.createElement("div", {
        className: "loading-more animated fadeIn is-faster"
      }, /*#__PURE__*/React.createElement("div", {
        className: "spinner-block"
      }, /*#__PURE__*/React.createElement(ProgressSpinner, {
        color: "#fff"
      })), /*#__PURE__*/React.createElement("div", {
        className: "text-block"
      }, "Loading older messages...")), /*#__PURE__*/React.createElement("div", {
        className: "inner"
      }, /*#__PURE__*/React.createElement(ScopeChangeRequestBanner, {
        scopeChangeRequests: this.props.scopeChangeRequests,
        showScopeChangeRequestResponseDialog: this.props.showScopeChangeRequestResponseDialog
      }), /*#__PURE__*/React.createElement("div", {
        ref: function ref(x) {
          _this4.root = x;
        },
        className: "conversation-group",
        onScroll: this.scroll
      }, children), typingIndicator), !this.isNearBottom && /*#__PURE__*/React.createElement("div", {
        className: "floating-actions animated fadeIn is-faster"
      }, /*#__PURE__*/React.createElement("a", {
        className: "scroll-to-bottom",
        onClick: function onClick() {
          return _this4.scrollToBottom();
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "scroll-to-bottom__icon"
      }, /*#__PURE__*/React.createElement(Icon, {
        material: true,
        small: true,
        name: "keyboard arrow down"
      })), /*#__PURE__*/React.createElement("span", {
        className: "scroll-to-bottom__text"
      }, scrollToBottom || 'Scroll to bottom'))));
    }
  }]);
}(Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "shouldScrollBottom", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "isNearBottom", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _class2)) || _class;
export { MessageScrollView as default };
MessageScrollView.propTypes = {
  children: PropTypes.node,
  isLoadingMore: PropTypes.bool,
  scrollToBottom: PropTypes.any,
  messageCount: PropTypes.number.isRequired,
  onLoadMore: PropTypes.func,
  scopeChangeRequests: PropTypes.array,
  showScopeChangeRequestResponseDialog: PropTypes.func,
  typingIndicator: PropTypes.node
};
//# sourceMappingURL=index.js.map
